// Test IDs for the My Writing feature. Naming follows the directive in
// ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const MY_WRITING = {
	page: 'my-writing-page',
	navLink: 'app-nav-my-writing',
	newCta: 'my-writing-new-cta',
	importCta: 'my-writing-import-cta',
	continueCard: 'my-writing-continue-card',
	grid: 'my-writing-grid',
	storyCard: 'my-writing-story-card',
	emptyCta: 'my-writing-empty-cta',
	editor: 'my-writing-editor',
	canvas: 'my-writing-canvas',
	toolbar: 'my-writing-toolbar',
	chapterSidebar: 'my-writing-chapter-sidebar',
	stats: 'my-writing-stats',
	preview: 'my-writing-preview',
	settingsPanel: 'my-writing-settings-panel',
};
